import { render, staticRenderFns } from "./legal_agreement_edit.vue?vue&type=template&id=815e390a&scoped=true"
import script from "./legal_agreement_edit.vue?vue&type=script&lang=js"
export * from "./legal_agreement_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815e390a",
  null
  
)

export default component.exports